import React from 'react';
import Navbar from '../components/Navbar';
import Heroimg from "../components/Heroimg";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div>
        <Navbar/>
        <Heroimg/>
        <Footer/>
    </div>
  )
}

export default Home